<div class="contenedor" style="width: 85%; margin: 0 auto;">

    <div class="titulo" style="margin-top:0 auto;text-align: center;">
        <h3>Crear Lista de Pagos</h3>
    </div>

    <form (ngSubmit)="Reporte(f)" #f="ngForm">

        <div class="form-row contenedorcheck mt-5">

            <div class="aspi" style="width: 250px;">

                <div class="form-group">
                    <div class="form-check">
                        <input [(ngModel)]="reporte.aspirantesx" name="aspirantesx" class="form-check-input" type="checkbox" id="gridCheck" [checked]="Aspirantes" (change)="testCheckAspirantes($event)" ngModel #aspirantesx="ngModel">
                        <label class="form-check-label" for="gridCheck">Aspirantes</label>
                    </div>

                </div>

            </div>

            <div class="inscri" style="width: 250px;">

                <div class="form-group">
                    <div class="form-check">
                        <input [(ngModel)]="reporte.inscripcionx" name="inscripcionx" class="form-check-input" type="checkbox" id="gridCheck2" [checked]="Inscripcion" (change)="testCheckInscripcion($event)" ngModel #inscripcionx="ngModel">
                        <label class="form-check-label" for="gridCheck2">Inscripción</label>
                    </div>

                </div>

            </div>

            <div class="reinsc" style="width: 250px;">

                <div class="form-group">
                    <div class="form-check">
                        <input [(ngModel)]="reporte.reinscripcionx" name="reinscripcionx" class="form-check-input" type="checkbox" id="gridCheck3" [checked]="Reinscripcion" (change)="testCheckReinscripcion($event)" ngModel #reinscripcionx="ngModel">
                        <label class="form-check-label" for="gridCheck3">Reinscripción</label>
                    </div>

                </div>

            </div>

            <div class="otros" style="width: 250px;">

                <div class="form-group">
                    <div class="form-check">
                        <input [(ngModel)]="reporte.otrosconceptosx" name="otrosconceptosx" class="form-check-input" type="checkbox" id="gridCheck4" [checked]="Otrosconceptos" (change)="testCheckOtrosconceptos($event)" ngModel #otrosconceptosx="ngModel">
                        <label class="form-check-label" for="gridCheck4">Otros conceptos</label>
                    </div>

                </div>

            </div>


            <div class="Todos" style="width: 250px;">

                <div class="form-group">
                    <div class="form-check">
                        <input name="todosx" class="form-check-input" type="checkbox" id="gridCheck5" [checked]="todos || (Otrosconceptos && Reinscripcion && Inscripcion && Aspirantes)" (change)="testCheckTodos($event)" ngModel #todosx="ngModel">
                        <label class="form-check-label" for="gridCheck5">Todos</label>
                    </div>
                </div>

            </div>

        </div>

        <hr>

        <div class="form-row mt-5">



            <div *ngIf="verinputplantel" class="form-group col-md-3">
                <label for="inputState" style="font-weight: 600;">Plantel</label>
                <input class="form-control" type="text" value="{{nombreplantel}} -- {{reporte.plantel}}" readonly>
            </div>


            <div *ngIf="vercomboplantel" class="form-group col-md-3">
                <label for="inputState" style="font-weight: 600;">Plantel</label>
                <select [(ngModel)]="reporte.plantel" name="plantelx" id="inputState" class="form-control" required [class.is-invalid]="plantelx.invalid && plantelx.touched" ngModel #plantelx="ngModel">
                    <option value="Todos">Todos</option>
                    <option value="{{plantel.idplantel}}" *ngFor="let plantel of planteles">{{plantel.nombreplantel}}</option>
            </select>
                <small *ngIf="plantelx.invalid && plantelx.touched" class="form-text text-danger animated fadeIn">Obligatorio</small>
            </div>

            <div class="form-group col-md-3">
                <label>Fecha de inicio:</label>

                <input type="date" [(ngModel)]="reporte.fachaini" name="fachaini" id="inputState" class="form-control" required>
            </div>
            <div class="form-group col-md-3">
                <label>Fecha de fin:</label>
                <input type="date" [(ngModel)]="reporte.fechafin" name="fechafin" id="inputState" class="form-control" required>
            </div>


        </div>

        <button type="submit" class="btn btn-outline-dark">Generar Lista</button>
    </form>
</div>